import { BehaviorSubject } from 'rxjs';
import phcMock from '../../assets/mocks/phc-data-mock.json';
import { PhcData } from '../models/interfaces/portfolio-health-check-data';
import { environment } from 'src/environments/environment';

type PHCUserType = 'no-goals' | 'eligible' | 'not-eligible'

const mockDataMapping: Record<PHCUserType, PhcData> = {
  'eligible': phcMock.eligible,
  'no-goals': phcMock.eligibleNull,
  'not-eligible': phcMock.notEligible,
};

class Mocker {
  isMocked: boolean;

  private phcMockedUserType: PHCUserType = 'not-eligible' 
  private phcMockedUser = mockDataMapping[this.phcMockedUserType]

  constructor() {
    this.isMocked = environment.IS_MOCKED ?? false;
  }

  /**
   * Sets the mock data for PHC chart data.
   * 
   * @param isLoading - BehaviorSubject to control the loading state
   * @param isFailure - BehaviorSubject to control the failure state
   * @param chartDataPayload - BehaviorSubject to hold the PHC data
   * @param mockData - Optional mock data to use instead of the default
   */
  mockedGetPhcData(
    isLoading: BehaviorSubject<boolean>,
    isFailure: BehaviorSubject<boolean>,
    chartDataPayload: BehaviorSubject<PhcData>,
  ) {
    try {
      isLoading.next(false);
      isFailure.next(false);

      chartDataPayload.next(this.phcMockedUser);
    } catch (error) {
      console.error('Error setting mock PHC data:', error);
      isFailure.next(true);
    }
  }

  /**
   * Sets the mock data for user channel broker validation.
   * 
   * @param isEligible - BehaviorSubject to control the eligibility state
   * @param isFailure - BehaviorSubject to control the failure state
   * @param mockEligible - Optional mock eligibility to use instead of the default
   */
  mockedValidateUserChannelBroker(
    isEligible: BehaviorSubject<boolean>,
    isFailure: BehaviorSubject<boolean>,
  ) {
    try {
      isFailure.next(false);
      isEligible.next(this.phcMockedUser.isEligible);
    } catch (error) {
      console.error('Error setting mock user channel broker validation:', error);
      isFailure.next(true);
    }
  }
}

export const mocker = new Mocker();
